<script setup lang="ts">
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { WidgetReviveAd } from '~/components/widget/revive-ad'
import { WidgetTrendingNews } from '~/components/widget/trending-news'
import { ContentEditor } from '~/components/ui/content'
import type { PolicyDocument } from '~/composables/usePrivacyPolicy'
import { useDateFormat } from '~/composables/useDateTimeFormat'
import { LucideCalendar, LucideTag } from 'lucide-vue-next'

const { t, locale } = useI18n()
const breadcrumbs = computed(() => [{ title: t('common.privacy_policy'), url: '/privacy-policy' }])

const { data: doc } = await useApi<PolicyDocument>('/system/documents', {
  query: { type: 'user_agreement' },
  key: `privacy-policy-${locale.value}`
})
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <ContentLayout>
        <template #right-sidebar>
          <aside>
            <WidgetTrendingNews />
            <WidgetReviveAd zoneid="27" class="overflow-hidden rounded-lg" />
          </aside>
        </template>
        <div class="lg:col-span-3" role="main">
          <ContentBlock variant="white">
            <Heading tag="h1">{{ doc?.name ?? $t('common.privacy_policy') }}</Heading>
            <ContentEditor v-if="doc" :html="doc.text" />
            <div
              v-if="doc"
              class="flex justify-between border-t bg-white pr-4 pt-4 text-sm [&_svg]:size-4"
            >
              <div class="flex items-center gap-4 text-gray-500">
                <div class="flex items-center gap-1">
                  <LucideCalendar />
                  <span
                    >{{ $t('form.register.privacy_modal_updated') }}
                    {{ useDateFormat(doc.updated_at) }}</span
                  >
                </div>
                <div class="flex items-center gap-1">
                  <LucideTag />
                  <span>{{ $t('form.register.privacy_modal_version') }} {{ doc.version }}</span>
                </div>
              </div>
            </div>
          </ContentBlock>
        </div>
      </ContentLayout>
    </Container>
  </Main>
</template>
